import { render, staticRenderFns } from "./RecommendActivityConfigPane.vue?vue&type=template&id=e6f9f6f6&scoped=true"
import script from "./RecommendActivityConfigPane.vue?vue&type=script&lang=js"
export * from "./RecommendActivityConfigPane.vue?vue&type=script&lang=js"
import style0 from "./RecommendActivityConfigPane.vue?vue&type=style&index=0&id=e6f9f6f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f9f6f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f9f6f6')) {
      api.createRecord('e6f9f6f6', component.options)
    } else {
      api.reload('e6f9f6f6', component.options)
    }
    module.hot.accept("./RecommendActivityConfigPane.vue?vue&type=template&id=e6f9f6f6&scoped=true", function () {
      api.rerender('e6f9f6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/recommend_activity/RecommendActivityConfigPane.vue"
export default component.exports